import { render, staticRenderFns } from "./RegistrosPisCofins.vue?vue&type=template&id=2023f983&scoped=true&"
import script from "./RegistrosPisCofins.vue?vue&type=script&lang=js&"
export * from "./RegistrosPisCofins.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosPisCofins.vue?vue&type=style&index=0&id=2023f983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023f983",
  null
  
)

export default component.exports